import React, {useEffect} from "react";
import {Paper} from "@material-ui/core";
import {withStyles} from "@material-ui/styles";
import PieChart, {
  Series,
  Connector,
  Size
} from 'devextreme-react/pie-chart';
import {Label as PieChartLabel} from 'devextreme-react/pie-chart';
import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Connector as ChartConnector,
  Label, Legend,
  SeriesTemplate
} from "devextreme-react/chart";
import useStatistic from "./useStatistic";

const styles = () => ({
  root: {
    marginBottom: 10,
    padding: 20,
  },
  container: {
    marginTop: 20,
  },
  chart: {
    height: "260px"
  },
});

const StatisticOneValueItem = ({value, caption, bgcolor}) => {
  return <div style={{marginBottom: 5}}>
    <div style={{backgroundColor: `${bgcolor}`, padding: 10, textAlign: "center", width: 80,
      fontSize: 16, fontWeight: 600, color: "white", display: "inline-block", marginRight: 10}}>
      {value}
    </div>
    <div style={{fontSize: 16, display: "inline-block"}}>{caption}</div>
  </div>
}

export const StatisticQuestionItem = ({question, classes}) => {
  const {statisticData, getQuestionStatisticItems} = useStatistic();

  useEffect(() => {
    if (question) {
      getQuestionStatisticItems(question.id);
    }
  }, []);

  return <Paper className={classes.root}>
    <strong>{'Вопрос ' + question.order + '. ' + question.question + (question.typeId === 7 ? (' (от ' + question.minValue + ' до ' +  question.maxValue + ')') : '')}</strong>
    <div className={classes.container}>
      {(question.typeId === 1 || question.typeId === 2 || question.typeId === 3) &&
        <StatisticOneValueItem caption={(statisticData &&
                                statisticData.statisticItems &&
                                statisticData.statisticItems.length > 0)
                                ? statisticData.statisticItems[0].caption : "Количество ответов"}
                               bgcolor="#70c92f"
                                value={(statisticData &&
                                  statisticData.statisticItems &&
                                  statisticData.statisticItems.length > 0)
                                  ? statisticData.statisticItems[0].value : 0}/>}

      {(question.typeId === 4 || question.typeId === 6)  && <>{statisticData.statisticItems && statisticData.statisticItems.length > 0 ?
      <PieChart dataSource={statisticData.statisticItems}
        palette="Bright">
        <Series
          argumentField="caption"
          valueField="value">
          <PieChartLabel visible={true}>
            <Connector visible={true} width={1} />
          </PieChartLabel>
        </Series>
        <Size width={500} />
      </PieChart> : <div>Ответы отсутствуют</div>}</>
      }

      {(question.typeId === 5) && <>{statisticData.statisticItems && statisticData.statisticItems.length > 0 ?
        <Chart resolveLabelOverlapping="stack"
               dataSource={statisticData.statisticItems}
               className={classes.chart}>
          <ArgumentAxis tickInterval={1}>
            <Label visible={true} format="decimal"/>
          </ArgumentAxis>
          <CommonSeriesSettings argumentField="caption" type="stackedBar" valueField="value">
            <Label visible={true}>
              <ChartConnector visible={true}/>
            </Label>
          </CommonSeriesSettings>
          <SeriesTemplate nameField="caption"/>
          <Legend visible={true} verticalAlignment="bottom" horizontalAlignment="center"/>
        </Chart> : <div>Ответы отсутствуют</div>}</>}

      {(question.typeId === 7) &&
      <div>
        {statisticData &&
        statisticData.statisticItems && statisticData.statisticItems.map((stItem,idx) => (
          <StatisticOneValueItem caption={stItem.caption}
                                 bgcolor="#1db2f5"
                                 value={stItem.value}/>
        ))}
      </div>}
    </div>
  </Paper>
}

export default withStyles(styles)(StatisticQuestionItem);
